/**
 * Polls reservation payment status for the confirmation page.
 *
 * Expects an element with id `reservation-payment-status-poller` and attributes:
 * - data-url: endpoint returning payment status JSON
 * - data-interval-ms: poll interval in milliseconds
 * - data-max-attempts: max number of polling attempts
 *
 * Reloads the page as soon as the backend reports the reservation is confirmed.
 */
export const startReservationPaymentStatusPolling = () => {
    /** @type {HTMLElement | null} */
    const pollerElement = document.querySelector('#reservation-payment-status-poller');

    if (!pollerElement) {
        return;
    }

    const statusUrl = pollerElement.getAttribute('data-url');
    const intervalMs = Number(pollerElement.getAttribute('data-interval-ms') || 3000);
    const maxAttempts = Number(pollerElement.getAttribute('data-max-attempts') || 5);

    if (!statusUrl) {
        return;
    }

    let attempts = 0;

    /**
     * Executes one polling request and reschedules itself until success/timeout.
     *
     * @returns {Promise<void>}
     */
    const poll = async () => {
        attempts++;

        try {
            const response = await fetch(statusUrl, {
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });

            if (!response.ok) {
                return;
            }

            const data = await response.json();

            if (data?.is_confirmed) {
                window.location.reload();
            }
        } catch (error) {
        } finally {
            if (attempts < maxAttempts) {
                setTimeout(poll, intervalMs);
            }
        }
    };

    setTimeout(poll, intervalMs);
};
